import { useQuery } from 'apollo-3';

import { announcements } from 'GraphQL/query/Announcement.query';
import { useConfig } from 'Context/ConfigContext';
import useGetDeviceInfo from 'Util/Hooks/useGetDeviceInfo';

import useMyExternalProfile from '../../Classroom/Domain/useMyExternalProfile';

import { ANNOUNCEMENT_TYPE, ANNOUNCEMENT_CATEGORY } from './constants';

const usePopupAnnouncement = ({ ...props }) => {
  const { data: myExternalProfileData } = useMyExternalProfile({ fetchPolicy: 'cache-only' });
  const { myCourses } = useConfig();
  const deviceInfo = useGetDeviceInfo();

  // Use toUpperCase so that the enum matches the gateway
  const platform = deviceInfo?.operatingSystem?.toUpperCase();

  const providerName = myExternalProfileData?.myExternalProfile?.providerName ?? '';
  const enablePopupAnnouncementByUserId = !!myCourses?.enablePopupAnnouncementByUserId;
  const enableFeatureAnnouncementByBU = myCourses?.enableFeatureAnnouncementByBU ?? [];

  const { data, loading, error } = useQuery(announcements, {
    variables: {
      platform,
      providerName,
      type: ANNOUNCEMENT_TYPE.NOTIFICATION,
      isIncludedUserAnnoucement: enablePopupAnnouncementByUserId,
    },
    skip: !platform || !enableFeatureAnnouncementByBU.includes(providerName),
    ...props,
  });

  // ! caution : this action below make popupAnnouncements mutated.
  const popupAnnouncements = data?.announcements.filter(
    (announcement) => announcement.category === ANNOUNCEMENT_CATEGORY.POPUP
  );

  return {
    popupAnnouncements,
    loading,
    error,
  };
};

export default usePopupAnnouncement;
